import React from "react";

import { IconWithBackgroundAttr, Layout } from "@multiweb/reactComponents";
import { bridge } from "@multiweb/reactCore/bridge";
import { IconCode } from "@multiweb/types/contracts";
import { AttributeComponent } from "../../LiteListFrameGeneralAttributeComponent";

const { stringToEnumValue } = bridge;

export const LiteListFrameIconAttribute: AttributeComponent = ({
    record,
    recordId,
    dataSourceAttribute,
    dataSourceAttributeInfo,
    interactive,
    title,
    hasBackgroundAttr,
}) => {
    if (!record || !dataSourceAttribute || !dataSourceAttributeInfo) {
        return null;
    }

    return (
        <Layout
            key={recordId}>
            <IconWithBackgroundAttr
                //stringToEnumValue může vracet undefined, proto přetypování as. Reálně to ale nastat nemůže, iconCanRenderDecider by měl zabránit tomu aby se sem dostala prázdná hodnota
                iconCode={stringToEnumValue(IconCode, record[dataSourceAttribute.attributeName].value) as IconCode }
                disabled={!interactive}
                hasBackgroundAttr={hasBackgroundAttr}
                {...{ title }}
            />
        </Layout>
    );
};
